import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { NotificationError } from '../components/common/common-componnets/Notifications';
import { TfaOptions } from '../constants/enums/tfa-options';
import { useGenerateCodeTwoFaMutation } from '../redux/features/auth/authApi';
import { setShowVerifyFA } from '../redux/slices/verifyFASlice';

export const useActivate2fa = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activate2FA, { isLoading }] = useGenerateCodeTwoFaMutation();

  const activateTfa = () => {
    activate2FA({
      twoWayAuthType: TfaOptions.googleAuth,
    })
      .unwrap()
      .then(response => {
        navigate('/two-fa', { state: response });
        dispatch(setShowVerifyFA(true));
      })
      .catch(() => NotificationError('Aktivizimi i 2FA dështoi!'));
  };

  return { activateTfa, isLoading };
};
